/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

export const SCENARIO_CARD_STYLE = {
  height: '100%',
  borderRadius: 2,
  cursor: 'pointer',
  transition: '0.2s',
  '&:hover': {
    boxShadow: 4,
  },
};
export const SCENARIO_CARD_CONTENT_STYLE = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};
export const CHIP_STYLE = {
  py: 0.3,
  minWidth: 0,
  height: 'auto',
  fontSize: 10,
  textTransform: 'capitalize',
};
export const CHIP_BOX_STYLE = { mt: 'auto', pt: 4, display: 'flex', flexWrap: 'wrap', gap: 1 };
export const SEARCH_INPUT_STYLE = {
  position: 'relative',
  maxWidth: 720,
  margin: '0 auto',
  border: '1px solid #ddd',
  borderRadius: 3,
  padding: '12px 52px 12px 14px',
  backgroundColor: '#fff',
};
export const SEARCH_TEXT_AREA_STYLE = {
  width: '100%',
  maxWidth: 900,
  padding: '2px',
  fontSize: '16px',
  lineHeight: 1.6,
  borderRadius: '12px',
  border: 'none',
  outline: 'none',
  resize: 'none',
  fontFamily: 'inherit',
};
export const SEND_BUTTON_STYLE = {
  position: 'absolute',
  right: 10,
  bottom: 10,
  backgroundColor: '#3b3a39',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#5e5e5c',
  },
};
export const DESCRIPTION_RENDER_STYLE ={
    color: '#2e384a',
    border: 1,
    borderColor: '#2e384a',
    borderRadius: 1.5,
    px: 1,
    fontSize: 10,
    textTransform: 'capitalize',
  }